export default "__VITE_ASSET__lR6CcS6i__"